/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationDetailResponse
 */
export interface InvitationDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof InvitationDetailResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationDetailResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationDetailResponse
     */
    role: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvitationDetailResponse
     */
    isAccepted: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvitationDetailResponse
     */
    teamName: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationDetailResponse
     */
    invitedByName: string;
}

/**
 * Check if a given object implements the InvitationDetailResponse interface.
 */
export function instanceOfInvitationDetailResponse(value: object): value is InvitationDetailResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('isAccepted' in value) || value['isAccepted'] === undefined) return false;
    if (!('teamName' in value) || value['teamName'] === undefined) return false;
    if (!('invitedByName' in value) || value['invitedByName'] === undefined) return false;
    return true;
}

export function InvitationDetailResponseFromJSON(json: any): InvitationDetailResponse {
    return InvitationDetailResponseFromJSONTyped(json, false);
}

export function InvitationDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'role': json['role'],
        'isAccepted': json['is_accepted'],
        'teamName': json['team_name'],
        'invitedByName': json['invited_by_name'],
    };
}

  export function InvitationDetailResponseToJSON(json: any): InvitationDetailResponse {
      return InvitationDetailResponseToJSONTyped(json, false);
  }

  export function InvitationDetailResponseToJSONTyped(value?: InvitationDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'role': value['role'],
        'is_accepted': value['isAccepted'],
        'team_name': value['teamName'],
        'invited_by_name': value['invitedByName'],
    };
}

